/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useRef, useState, useMemo } from 'react';
import { Row, Col, Form, Input, Button, TreeSelect, Select, Checkbox, notification, message, Spin } from 'antd';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
// import { withRouter } from 'react-router-dom';
import { PlusCircleOutlined } from '@ant-design/icons';
import './payments_data_entry.css';
import PaymentHistModal from '../payment_hist_modal';
import SearchPagerRight from 'shared_components/search_pager_right';
import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';
import { TABLE_HEADER_STYLE, TABLE_CELL_STYLE, TABLE_PAGINATION_STYLE } from 'utils/tableStyles';

import { numberFormat } from 'utils/helper';
import { isEqual, differenceWith } from 'lodash';
// import Message from 'shared_components/message';

import {
	fetchEwt,
	fetchPaymentDetails,
	fetchInvoiceHistory,
	tmpDeleteDetail,
	fetchBalanceDetailsAPI,
	fetchBalanceDetailsNewStatusAPI,
} from 'services/payments/payments';

import './payments_data_entry.css';

// const { Content: AntContent } = Layout;
const EditableContext = React.createContext(null);
const { TreeNode } = TreeSelect;
const { Option } = Select;

const MAX_EDIT_DECIMALS = 7;

function normalizeDecimalInput(value, maxDecimals = null) {
	if (value === undefined || value === null) return '';

	let text = String(value).replace(/,/g, '');
	text = text.replace(/[^\d.]/g, '');

	const dotIndex = text.indexOf('.');
	if (dotIndex !== -1) {
		const intPart = text.slice(0, dotIndex);
		const decPartRaw = text.slice(dotIndex + 1).replace(/\./g, '');
		const hasDecimalLimit = Number.isInteger(maxDecimals) && maxDecimals >= 0;
		const decPart = hasDecimalLimit ? decPartRaw.slice(0, maxDecimals) : decPartRaw;
		return decPartRaw.length > 0 ? `${intPart}.${decPart}` : `${intPart}.`;
	}

	return text;
}

function formatCurrencyForDisplay(value) {
	const normalized = normalizeDecimalInput(value, MAX_EDIT_DECIMALS);
	if (normalized === '' || normalized === '.') return numberFormat(0, 2);

	const numeric = parseFloat(normalized);
	if (Number.isNaN(numeric)) return numberFormat(0, 2);

	const decimalPart = normalized.includes('.') ? normalized.split('.')[1] : '';
	const decimalPlaces = Math.max(2, decimalPart.length);
	return numberFormat(numeric, decimalPlaces);
}

function getRawEditableValue(value) {
	const normalized = normalizeDecimalInput(value, MAX_EDIT_DECIMALS);
	if (normalized === '' || normalized === '.') return '';
	if (!normalized.includes('.')) return normalized;

	const [intPart, decimalPart = ''] = normalized.split('.');
	if (decimalPart === '' || /^0+$/.test(decimalPart)) {
		return intPart;
	}

	return `${intPart}.${decimalPart}`;
}

const EditableRow = ({ index, ...props }) => {
	const [form] = Form.useForm();
	return (
		<Form form={form} component={false}>
			<EditableContext.Provider value={form}>
				<tr {...props} />
			</EditableContext.Provider>
		</Form>
	);
};

const EditableCell = ({
	title,
	editable,
	children,
	dataIndex,
	record,
	handleSave,
	...restProps
}) => {
	const [editing, setEditing] = useState(false);
	const inputRef = useRef(null);
	const form = useContext(EditableContext);
	const [ewt , setEwt] = useState([]);
	const [draftValue, setDraftValue] = useState('');

	async function getLOVList(){
		try{
			const getEwt = await fetchEwt();
			setEwt(getEwt);
		}catch(error){
			console.log("error", error);
		}
	};

	useEffect( ()=> {
        function fetchData() {
            getLOVList();
        }
		fetchData();
	}, []);

	//get status list
    const ewtOptions = ewt.map((item, index) => {
        return(
            <Option key={index} value={item.ewt_desc}>{item.ewt_desc}</Option>
        ); 
    });

	useEffect(() => {
		const isNumericField = dataIndex === 'amount' || dataIndex === 'ewt_amount';
		if (!editing || dataIndex === 'full_payment') return;

		requestAnimationFrame(() => {
			const inputElement = inputRef.current && (inputRef.current.input || inputRef.current);
			if (!inputElement) return;

			inputElement.focus();

			if (isNumericField) {
				const rawValue = getRawEditableValue(record[dataIndex]);
				inputElement.value = rawValue;
				try {
					const caret = rawValue.length;
					inputElement.setSelectionRange(caret, caret);
				} catch (error) {
					// Ignore if input does not support caret controls.
				}
			}
		});
	}, [editing, dataIndex, record]);

	const toggleEdit = () => {
		const editableNumericFields = ['amount', 'ewt_amount'];
		let fieldValue = record[dataIndex];
		if (editing) return;

		if (editableNumericFields.includes(dataIndex)) {
			fieldValue = getRawEditableValue(fieldValue);
			setDraftValue(fieldValue);
			setEditing(true);
			return;
		}

		setEditing(true);
		form.setFieldsValue({
			[dataIndex]: fieldValue,
		});
	};

	const saveNumericDraft = event => {
		const rawInputValue =
			(event && event.target && event.target.value) ||
			(inputRef.current && (inputRef.current.input || inputRef.current).value) ||
			draftValue;
		const normalized = normalizeDecimalInput(rawInputValue, MAX_EDIT_DECIMALS);
		const committed = normalized === '' ? '0' : normalized;
		setEditing(false);
		handleSave({ ...record, [dataIndex]: committed }, { [dataIndex]: committed });
	};

	const handleNumericTyping = event => {
		const inputElement = event.target;
		const originalValue = inputElement.value;
		const selectionStart = inputElement.selectionStart;
		const selectionEnd = inputElement.selectionEnd;
		const cleanedValue = normalizeDecimalInput(originalValue, MAX_EDIT_DECIMALS);

		if (originalValue === cleanedValue) return;

		const beforeStart = originalValue.slice(0, selectionStart || 0);
		const beforeEnd = originalValue.slice(0, selectionEnd || 0);
		const cleanedBeforeStart = normalizeDecimalInput(beforeStart, MAX_EDIT_DECIMALS);
		const cleanedBeforeEnd = normalizeDecimalInput(beforeEnd, MAX_EDIT_DECIMALS);
		const nextStart = cleanedBeforeStart.length;
		const nextEnd = cleanedBeforeEnd.length;

		inputElement.value = cleanedValue;
		requestAnimationFrame(() => {
			try {
				inputElement.setSelectionRange(nextStart, nextEnd);
			} catch (error) {
				// Ignore if browser/input does not support caret controls.
			}
		});
	};

	const save = async () => {
		try {
			const values = await form.validateFields();
			const normalizedValues = { ...values };

			if (Object.prototype.hasOwnProperty.call(normalizedValues, 'amount')) {
				const cleanAmount = normalizeDecimalInput(normalizedValues.amount, MAX_EDIT_DECIMALS);
				normalizedValues.amount = cleanAmount === '' ? '0' : cleanAmount;
			}

			if (Object.prototype.hasOwnProperty.call(normalizedValues, 'ewt_amount')) {
				const cleanEwtAmount = normalizeDecimalInput(normalizedValues.ewt_amount, MAX_EDIT_DECIMALS);
				normalizedValues.ewt_amount = cleanEwtAmount === '' ? '0' : cleanEwtAmount;
			}

			if (dataIndex !== 'full_payment') {
				setEditing(false);
				// handleSave({ ...record, ...values }, values);
			}
			handleSave({ ...record, ...normalizedValues }, normalizedValues);		
		} catch (errInfo) {
			console.log('Save failed:', errInfo);
		}
	};

	const handleFullOnChange = e => {
		const checkPayment = e.target.checked;
		form.setFieldsValue({ full_payment: checkPayment });
		save();
	};

	let childNode = children;

	if (editable) {
		if (dataIndex === 'ewt') {

			const ewtIsDisabled = () =>{
				switch(record.payment_status){
					case undefined:
						return false;
						break;
					
					case 'NEW':
						return false;
						break;
					default:
						return true;
				}
			};

			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
					rules={[
						{
							required: true,
							message: `${title} is required.`,
						},
					]}
				>
					<Select
						placeholder="EWT"
						ref={inputRef}
						onBlur={save}
						onChange={save}
						// showSearch
						allowClear={true}
						filterOption={(input, option) =>
							option.children.toLowerCase().includes(input.toLowerCase())
						}
						disabled={ewtIsDisabled()}
					>
						{ewtOptions}
					</Select>
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
					}}
					onClick={toggleEdit}
					onFocus={toggleEdit}
				>
					{children}
				</div>
			);
		} // ewt
		else if (dataIndex === 'ewt_amount') {

			const ewtAmountIsDisabled = () =>{
				switch(record.payment_status){
					case undefined:
						return false;
						break;
					
					case 'NEW':
						return false;
						break;
					default:
						return true;
				}
			};

			childNode = editing ? (
				<Input
					ref={inputRef}
					defaultValue={draftValue}
					onChange={handleNumericTyping}
					onPressEnter={saveNumericDraft}
					onBlur={saveNumericDraft}
					inputMode="decimal"
					disabled={ewtAmountIsDisabled()}
				/>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
					}}
					onClick={toggleEdit}
				>
					{children}
				</div>
			);
		} // end ewt amount
		else if (dataIndex === 'amount') {

			const amountIsDisabled = () =>{
				switch(record.payment_status){
					case undefined:
						return false;
						break;
					
					case 'NEW':
						return false;
						break;
					default:
						return true;
				}
			};
			childNode = editing ? (
				<Input
					ref={inputRef}
					defaultValue={draftValue}
					onChange={handleNumericTyping}
					onPressEnter={saveNumericDraft}
					onBlur={saveNumericDraft}
					inputMode="decimal"
					disabled={amountIsDisabled()}
				/>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
					}}
					onClick={toggleEdit}
				>
					{children}
				</div>
			);
		} // end amount
		else if (dataIndex === 'full_payment') {

			const fullPayIsDisabled = () =>{
				switch(record.payment_status){
					case undefined:
						return false;
						break;
					
					case 'NEW':
						return false;
						break;
					default:
						return true;
				}
			};

			childNode = !editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
				>
					<Checkbox 
						ref={inputRef} 
						onChange={handleFullOnChange} 
						checked={record.full_payment}
						disabled={fullPayIsDisabled()}
					/>
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
					}}
					onClick={toggleEdit}
				>
					<Checkbox onChange={handleFullOnChange} checked={record.full_payment} />
				</div>
			);
		} // end full payment
		else
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
					rules={[
						{
							required: true,
							message: `${title} is required.`,
						},
					]}
				>
					<Input ref={inputRef} onPressEnter={save} onBlur={save} />
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
					}}
					onClick={toggleEdit}
				>
					{children}
				</div>
			);
	}

	return <td {...restProps}>{childNode}</td>;
};

function PaymentsDataTable({ 
		handleTotVal, handleTotDue, handleTotEwt, handleTotVatSales, handleTotVatAmount, paymentsDetail, invoiceDetailsProps, 
		isEditting, forDelete, status, customerID, invBalDet, clearPaymentLines, headerForm}) {
	const [dataSource, setDataSource] = useState([]);
	console.log('invoiceDetailsProps table', invoiceDetailsProps)
	const [data, setData] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [pageSize, setPageSize] = useState(GLOBAL_TABLE_PAGE_SIZE);
	const [page, setPage] = useState(0);
	const [invoiceData, setInvoiceData] = useState([]);
	const [count, setCount] = useState(2);
	const [invHistData, setInvHistData] = useState({});
	const [linesForDelete, setLinesForDelete] = useState([]);
	const [tableLoading, setTableLoading] = useState(isEditting);
	const [balDet, setBalDet] = useState([]);
	const [treeSearchValue, setTreeSearchValue] = useState('');
	const [userInteracted, setUserInteracted] = useState(false);
	const [totalsChangeType, setTotalsChangeType] = useState('init'); // init | value | structure
	const hideEWTColumns = true;

	useEffect(() => {
		if (isEditting) {
			async function fetchData() {
				if (isEditting) {
					const getPayment_id = {
						payment_id: invoiceDetailsProps.payment_id,
					};
					const PaymentDetails = await fetchPaymentDetails(getPayment_id);
					// Preserve API figures for invoice and due; use amount fallback only when needed.
					const mappedPaymentDetails = PaymentDetails.map(detail => ({
						...detail,
						invoice_amount: detail.invoice_amount || detail.total_amount_due || detail.balance,
						total_amount_due: detail.total_amount_due || detail.invoice_amount || detail.balance,
						amount: detail.amount || detail.payment_amount
					}));
					setDataSource(mappedPaymentDetails);
					setTableLoading(false);
				}
			}
			fetchData();
		} else {
			setTableLoading(false);
		}
	}, []);

	useEffect(() => {
		paymentsDetail(dataSource);
		console.log('dataSource =>', dataSource)
	}, [dataSource]);

	useEffect(()=>{
		forDelete(linesForDelete);
	}, [linesForDelete]);

	useEffect(()=>{
		let clearedLines = [];

		if(isEditting){
			dataSource.forEach(rec=> clearedLines.push(rec.payment_line_id));
			setLinesForDelete(clearedLines);
		}		
		setTotalsChangeType('structure');
		setUserInteracted(true);
		setDataSource([]);
	}, [clearPaymentLines]);

	const handleDelete = async data => {
		// Safeguard: Do not allow deletion if editing a record that is already POSTED or otherwise not NEW
		if (isEditting && status !== 'NEW') {
			message.warning('Cannot delete lines from a transaction that is already ' + status);
			return;
		}

		console.log('data =>', data);

		const newData = dataSource.filter(item => item.key !== data.key);
		setDataSource(newData);
		setUserInteracted(true);
		setTotalsChangeType('structure');
		setLinesForDelete(linesForDelete.concat(data.payment_line_id));

		const tmpDel = await tmpDeleteDetail(data.payment_line_id);
		const effectiveStatus = status || (invoiceDetailsProps && invoiceDetailsProps.status_name) || 'NEW';
		const updBalDet = (isEditting && effectiveStatus === 'NEW')
			? await fetchBalanceDetailsNewStatusAPI(customerID, invoiceDetailsProps && invoiceDetailsProps.payment_id)
			: await fetchBalanceDetailsAPI(customerID);
		setBalDet(updBalDet);
	};

	useEffect(()=> {
		console.log('🔥 [PaymentsDataTable] invBalDet prop received:', invBalDet);
		console.log('🔥 [PaymentsDataTable] invBalDet length:', invBalDet ? invBalDet.length : 0);
		setBalDet(invBalDet);
		console.log('🔥 [PaymentsDataTable] balDet state updated');
	}, [invBalDet]);

	const defaultColumns = [
		{
			title: 'INVOICE NO',
			dataIndex: 'invoice_no',
			key: 'invoice_no',
			width: '15%',
			render: (text, record) => {
				if (text === 'SELECT_INVOICE') {
					console.log('🔥 [Column Render] Rendering Select with options length:', invoiceOptions.length);
					console.log('🔥 [Column Render] Options sample:', invoiceOptions.slice(0, 2));
					return (
						<Select
							showSearch
							style={{ width: '100%' }}
							placeholder="Type to search invoice number..."
							onSelect={handleOnSelect}
							options={invoiceOptions}
							virtual={true}
							filterOption={(input, option) =>
								option.label.toLowerCase().includes(input.toLowerCase())
							}
						/>
					);
				}
				return text;
			},
		},
		{
			title: 'INVOICE AMOUNT',
			dataIndex: 'invoice_amount',
			key: 'invoice_amount',
			width: '15%',
		},
		{
			title: 'FULL',
			dataIndex: 'full_payment',
			key: 'full_payment',
			width: '5%',
			editable: true,
		},
		// Conditionally add the "EWT" column
		...(hideEWTColumns ? [] : [{
			title: 'EWT',
			dataIndex: 'ewt',
			key: 'ewt',
			width: '10%',
			editable: true,
			render: (_, record) =>
				dataSource.length >= 1 ? (
					<Input className='editableCellInput' value={record.ewt} disabled={isAddLineDisabled} />
				) : null,
		}]),
		// Conditionally add the "EWT AMOUNT" column
		...(hideEWTColumns ? [] : [{
			title: 'EWT AMOUNT',
			dataIndex: 'ewt_amount',
			key: 'ewt_amount',
			width: '15%',
			editable: true,
			render: (_, record) =>
				dataSource.length >= 1 ? (
					<Input className='editableCellInput' value={record.ewt_amount} disabled={isAddLineDisabled} />
				) : null,
		}]),
		{
			title: 'PAYMENT AMOUNT',
			dataIndex: 'amount',
			key: 'amount',
			width: '15%',
			editable: true,
			render: (_, record) =>
				dataSource.length >= 1 ? (
					<Input className='editableCellInput' value={record.amount} disabled={isAddLineDisabled} />
				) : null,
		},
		{
			title: 'OPERATION',
			dataIndex: 'operation',
			width: '20%',
			render: (_, record) =>
				dataSource.length >= 1 ? (
					<div>
						<a 
							onClick={() => handleDelete(record)} 
							style={{ textTransform: 'capitalize' }} 
							className={(isEditting && status !== 'NEW') ? 'isDisabled' : 'isEnabled'}
						>
							DELETE
						</a>
						<> | </>
						{record.key === 0 || (
							<a
								style={{ textTransform: 'capitalize' }}
								href=""
								onClick={event => {
									event.preventDefault();
									showInvoiceHistory(record.invoice_no);
									setShowModal(true);
								}}
							>
								VIEW HISTORY
							</a>
						)}
					</div>
				) : null,
		},
	];

	async function showInvoiceHistory (data){
        const invoiceHistory = await fetchInvoiceHistory(data);
        setInvHistData(invoiceHistory);
        setShowModal(true);
    };


	function computeEwtAmount(percent, amount){
	//wrote to recompute the EWT amount as defining it in a const var doesn't work onChange events.
	//used in handleSave

	const parsedRate = parseFloat(percent.toString().replace(/%,/g, ''));
	const parsedAmount = parseFloat(amount.toString().replace(/,/g, ''))/1.12; //removes 12% vat amount from invoice
	return numberFormat(((parsedRate * parsedAmount) / 100), 2);
	}

	const handleSave = (row, val) => {
		setUserInteracted(true);
		setTotalsChangeType('value');
		const newData = [...dataSource];
		const index = newData.findIndex(item => row.key === item.key);
		const item = newData[index];

		console.log('row =>', row);

		if(row.ewt !== item.ewt && val.ewt !== undefined){
			// console.log('check val ewt', val); 
			row.ewt_amount = computeEwtAmount(row.ewt, row.amount);
			
			// set full payment to initial value if undefined
			if(val.full_payment === undefined){
				row.full_payment = item.full_payment;
			}
		}

		// checkfullpayment
		if (row.full_payment !== item.full_payment && val.full_payment !== undefined) {

			if (!row.full_payment) {
				row.ewt_amount = computeEwtAmount(row.ewt, row.amount);
			} else {
				row.amount = row.balance;
				row.ewt_amount = computeEwtAmount(row.ewt, row.amount)
			}
		}

		if(val.amount !== undefined){
			row.ewt_amount = computeEwtAmount(row.ewt, row.amount);

			const row_bal_format = numberFormat( parseFloat(row.balance.toString().replace(/,/g, '')), 2 );
			const row_amt_format = numberFormat( parseFloat(row.amount.toString().replace(/,/g, '')), 2 );

			//set full payment
			if(row_amt_format !== row_bal_format){
				row.full_payment = false;
				// console.log('check < amount', row.full_payment)
			}else{
				row.full_payment = true;
				// console.log('check else amount', row.full_payment)
			}
		}

		if (val.amount !== undefined || val.full_payment !== undefined) {
			row.amount = formatCurrencyForDisplay(row.amount);
		}

		if (
			val.ewt !== undefined ||
			val.amount !== undefined ||
			val.full_payment !== undefined ||
			val.ewt_amount !== undefined
		) {
			row.ewt_amount = formatCurrencyForDisplay(row.ewt_amount);
		}

		newData.splice(index, 1, { ...item, ...row });
		setDataSource(newData);
	};

	const openNotificationWithIcon = type => {
		notification.destroy();
		notification[type]({
			message: 'Warning',
			description: 'Payment Amount should not exceed Invoice Amount.',
			placement: 'topRight',
			duration: 5,
		});
	};

	const components = {
		body: {
			row: EditableRow,
			cell: EditableCell,
		},
	};
	const columns = defaultColumns.map(col => {
		if (!col.editable) {
			return col;
		}

		return {
			...col,
			onCell: record => ({
				record,
				editable: col.editable,
				dataIndex: col.dataIndex,
				title: col.title,
				handleSave,
			}),
		};
	});

	async function handleOnSelect(value) {
		const invoiceNumber = value;
		const filterInvBal = balDet.filter(item => item.key === invoiceNumber);

		const formatInvBal = filterInvBal.map(value => {
			return {
				...value,
				invoice_id: value.key,  // Map 'key' to 'invoice_id' for database save
				ewt: '0%',
				ewt_amount: 0.00,
				amount: (value.balance || value.total_amount_due || value.invoice_amount || '').toString().trim(),
				full_payment: true,
				vatable_sales: value.vatable_sales,
				invoice_amount: (value.invoice_amount || '').toString().trim(),
				total_amount_due: (value.total_amount_due || '').toString().trim(),
				balance: (value.balance || value.total_amount_due || value.invoice_amount || '').toString().trim()
			};
		});

		setInvoiceData(formatInvBal);

		// Remove any SELECT_INVOICE placeholder rows before adding the actual invoice
		const cleanedDataSource = dataSource.filter(item => item.invoice_no !== 'SELECT_INVOICE');
		
		// Add the selected invoice data
		if (formatInvBal.length > 0) {
			setUserInteracted(true);
			setTotalsChangeType('structure');
			return setDataSource([...cleanedDataSource, ...formatInvBal]);
		}
		setUserInteracted(true);
		setTotalsChangeType('structure');
		return setDataSource(cleanedDataSource);
	}

	const invoiceOptions = useMemo(() => {
		const getArrayInvoice = balDet || [];
		const getArrayTable = dataSource || [];
		console.log('🔥 [invoiceOptions] balDet length:', getArrayInvoice.length);
		console.log('🔥 [invoiceOptions] dataSource length:', getArrayTable.length);

		// Filter out already selected invoices
		// Backend returns 'key' field, so we use that for comparison
		const filteredData = differenceWith(getArrayInvoice, getArrayTable, (inv, tbl) => inv.key === tbl.key);
		console.log("🚀 ~ PaymentsDataTable ~ filteredData:", filteredData)
		

		const options = filteredData.map(item => ({
			value: item.key,
			label: `${item.invoice_no} | Amount: ${item.total_amount_due} | Balance: ${item.balance}`,
			searchText: item.invoice_no
		}));
		console.log("🚀 ~ PaymentsDataTable ~ options:", options)
		
		return options;
	}, [balDet, dataSource]);

	const handleAdd = () => {
		setUserInteracted(true);
		setTotalsChangeType('structure');
		const newData = {
			key: count,
			payment_line_id: count,
			invoice_no: 'SELECT_INVOICE',
			ewt: '0%',
			ewt_amount: '0.00',
			full_payment: false,
			balance: '0.00',
			invoice_amount: '0.00',
			description: '-',
			amount: '0.00',
			vatable_sales: '0.00',
			vat_amount: '0.00'
		};
		setDataSource([...dataSource, newData]);
		setCount(count + 1);
	};

	//handle invoice total amount
	const selectInvoiceAmt = dataSource.map(amt => {
    const val = amt.total_amount_due !== undefined && amt.total_amount_due !== null
        ? amt.total_amount_due.toString().replace(/,/g, '')
        : '0';
    return parseFloat(val) ? parseFloat(val) : 0.0;
});
const totInvoiceAmt = selectInvoiceAmt.reduce((result, amt) => result + amt, 0.0);
	
	const linePaymentAmt = dataSource.map(amt => {
		const val = (amt.amount && typeof amt.amount === 'string') 
			? amt.amount.replace(/,/g,'') 
			: (amt.amount || 0);
		return parseFloat(val) ? parseFloat(val) : 0.0
	});

	const totPaymentAmt = linePaymentAmt.reduce((result, amt) => result + amt, 0.0);

	//handle invoice ewt amount
	const selectEwtAmt = dataSource.map(ewt =>{
		const val = (ewt.ewt_amount && typeof ewt.ewt_amount === 'string')
			? ewt.ewt_amount.replace(/,/g, '')
			: (ewt.ewt_amount || 0);
		return parseFloat(val) ? parseFloat(val) : 0.0;
	});

	//handle invoice vatable_sales
	const selectVatableSales = dataSource.map(vt =>{
		const val = (vt.vatable_sales && typeof vt.vatable_sales === 'string')
			? vt.vatable_sales.replace(/,/g, '')
			: (vt.vatable_sales || 0);
		return parseFloat(val) ? parseFloat(val) : 0.0;
	});
	const totVatableSales= selectVatableSales.reduce((result, vt) => result + vt, 0.0);
	//handle invoice vat amount
	const selectVatAmount = dataSource.map(vat =>{
		const val = (vat.vat_amount && typeof vat.vat_amount === 'string')
			? vat.vat_amount.replace(/,/g, '')
			: (vat.vat_amount || 0);
		return parseFloat(val) ? parseFloat(val) : 0.0;
	});
	const totVatAmount= selectVatAmount.reduce((result, vat) => result + vat, 0.0);

	const totEwtAmt = selectEwtAmt.reduce((result, ewt_amount) => result + ewt_amount, 0.0);

	// Summation logic for header totals
	useEffect(() => {
		if (!tableLoading) {
			// In Edit Mode, skip auto-summation until the user actually interacts with the table
			// This preserves the initial values from the API/Database
			if (isEditting && !userInteracted) {
				console.log('🔥 [DataTable] Initialization: Skipping summation update to preserve API totals');
				return;
			}
			const effectiveStatus = status || invoiceDetailsProps.status_name || 'NEW';
			const isEditNewStatus = isEditting && effectiveStatus === 'NEW';
			const isStructureChange = totalsChangeType === 'structure';
			console.log('🔥 [DataTable] Interaction Detected/New Mode: Updating header with calculated totals');
			if (!isEditNewStatus || isStructureChange) {
				handleTotVal(totInvoiceAmt.toFixed(2));
			}
			handleTotDue(totPaymentAmt.toFixed(2));
			handleTotVatSales(totVatableSales.toFixed(2));
			handleTotVatAmount(totVatAmount.toFixed(2));
			handleTotEwt(totEwtAmt.toFixed(2));
		}
	}, [tableLoading, totInvoiceAmt, totPaymentAmt, totVatableSales, totVatAmount, totEwtAmt, userInteracted, isEditting, status, invoiceDetailsProps.status_name, totalsChangeType]);

	const isAddLineDisabled = (()=>{
		const status = !invoiceDetailsProps.status_name ? 'NEW' : invoiceDetailsProps.status_name
		if(status !== 'NEW'){
			return true;
		}else if(customerID === undefined){
			return true;
		}else{
			return false;
		}
	})();	

	return (
		<div>
			<Row style={{ marginTop: 5, marginBottom: 5 }}>
				<Col span={12}>
					<Button
						onClick={handleAdd}
						type="primary"
						style={{ marginTop: 5 }}
						icon={<PlusCircleOutlined />}
						disabled={isAddLineDisabled}
					>
						ADD PAYMENT LINE
					</Button>
				</Col>
				<Col span={12}>
					<SearchPagerRight pageTotal={dataSource.length} pageSize={pageSize} />
				</Col>
			</Row>
			   <Row gutter={[8, 1]} justify="center">
				   <Col span={24}>
					   <TableContainer component={Paper}>
						   <Table style={{ textTransform: 'uppercase' }}>
							   <TableHead>
								   <TableRow>
									   {columns.map(col => (
										   <TableCell key={col.key} style={TABLE_HEADER_STYLE}>{col.title}</TableCell>
									   ))}
								   </TableRow>
							   </TableHead>
							   <TableBody>
								   {dataSource.map((row, rowIndex) => (
									   <EditableRow key={row.key} index={rowIndex}>
										   {columns.map(col => {
											   if (col.editable) {
												   return (
													   <EditableCell
														   key={col.key}
														   title={col.title}
														   editable={col.editable}
														   dataIndex={col.dataIndex}
														   record={row}
														   handleSave={handleSave}
													   >
														   {row[col.dataIndex]}
													   </EditableCell>
												   );
											   }
											   return (
												   <TableCell key={col.key} style={TABLE_CELL_STYLE}>
													   {col.render ? col.render(row[col.dataIndex], row) : row[col.dataIndex]}
												   </TableCell>
											   );
										   })}
									   </EditableRow>
								   ))}
							   </TableBody>
						   </Table>
						   <TablePagination
							   component="div"
							   count={dataSource.length}
							   page={page}
							   onPageChange={(event, newPage) => setPage(newPage)}
							   rowsPerPage={pageSize}
							   onRowsPerPageChange={event => {
								   setPageSize(parseInt(event.target.value, 10));
								   setPage(0);
							   }}
							   rowsPerPageOptions={[]}
							   style={TABLE_PAGINATION_STYLE}
						   />
					   </TableContainer>
				   </Col>
			   </Row>
			<PaymentHistModal
				visible={showModal}
				data={invHistData}
				hideModal={() => {
					setShowModal(false);
				}}
			/>
		</div>
	);
}

export default PaymentsDataTable;
